import React from 'react';
import DeviceStatusList from '../deviceStatus/DeviceStatusList';
import TransactionDayList from '../transactionDayList/TransactionDayList'
import TransactionDayPicker from '../transactionDayList/TransactionDayPicker'
import MenuPage from '../../pages/MenuPage';
import Tile from '../tile/Tile';
import { Grid, Row, Col } from 'react-flexbox-grid';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import FontIcon from 'material-ui/FontIcon';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconButton from 'material-ui/IconButton';
import ExportForm from '../../components/export/ExportForm';
import moment from 'moment';
import {ROOT_URL} from '../../store/actions/util'
import {LoomisColors} from '../../lib/LoomisColors';
import branchIcon from '../../img/retail.svg';
import translate from '../../lib/i18n/translate'
import numeral from 'numeral';

import './Branch.css'
import {ChartSlider} from "../chart/ChartSlider";

const Branch = (props) => {

    const { branch, salesByDate, onOperatorsClick, openExportDialog, exportDialog, mobile, denominationDetails, openTransactionDay, openTransactionDayPick } = props;
    const {closeExportDialog, cancelExportDialog} = props;

    const {ExportTransactions, ManageOperators, ShowOnMap, CurrentBalance, DailySales, TransactionDays} = props.strings;

    const handleExportDialogClose = (range) => {
        if(range){

            let startTime = moment(range.start).format("YYYY-MM-DD HH:mm:ss");
            let endTime = moment(range.end).format("YYYY-MM-DD HH:mm:ss");

            let url = ROOT_URL+ "/api/v1/branches/" + branch.id + "/transactions/export?"
                +"startDate=" + encodeURIComponent(startTime)
                + "&endDate=" + encodeURIComponent(endTime);

            closeExportDialog(range);

            window.open(url);

        } else {
            cancelExportDialog(range);
        }
    };

    const iconStyle = {
        fontSize: '1.2rem',
        color:LoomisColors.white
    };

    const menuIconStyle = {
        color:LoomisColors.white,
        marginTop: -6,
        marginRight: -16,
      }
    const iconStyles = {
        fontSize: '2.4rem',
        color: LoomisColors.darkBlue,
    };

    const Menu = (props) => (
        <IconMenu
            {...props}

            iconButtonElement={
                <IconButton style={{color:LoomisColors.White}} iconStyle={menuIconStyle}><MoreVertIcon /></IconButton>
            }
            targetOrigin={{horizontal: 'right', vertical: 'top'}}
            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
        >
            <MenuItem primaryText={ExportTransactions} onTouchTap={openExportDialog}/>
            <MenuItem primaryText={ManageOperators} onTouchTap={onOperatorsClick}/>
        </IconMenu>
    );

    return (
        <MenuPage title={branch.name} menu={<Menu/>} onBackClick={()=>{props.history.goBack()}}>
            <ExportForm open={exportDialog.open}
                        start={exportDialog.range.start}
                        end={exportDialog.range.end}
                        handleClose={handleExportDialogClose}/>

            <div className="container">
                <div className="BranchHeader">
                    <Row middle="xs">
                        <Col xs={6} sm={8} md={8} lg={8} >
                            <div className="BranchIcon">
                                <img src={branchIcon} alt="Branch icon"/>
                            </div>
                            <div className="BranchAdress">{branch.adress1}</div>
                            <div className="BranchAdress">{branch.adress2}</div>
                        </Col>
                        <Col xs={6} sm={4} md={4} lg={4} >
                            <FontIcon className="MapIcon material-icons" onClick={()=>props.showMap()} style={iconStyles}>place</FontIcon>
                            <div className="Map" onClick={()=>props.showMap()}>{ShowOnMap}</div>
                        </Col>
                    </Row>
                </div>
                <Grid fluid>
                    <Row>
                        <Col xs={12}>
                            <ChartSlider periodLength={mobile?7:undefined} mainCurrency={branch.mainCurrency} salesByDate={salesByDate} denominationDetails={denominationDetails} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} sm={6} md={6} lg={6} >
                            <Tile type="balance" title={CurrentBalance} data={
                                branch.balanceThisDay.map((b,i) => <div key={i}><div className="Amount">{numeral(b.amount/100).format('0,0.00')}</div><div className="Currency">{b.currency}</div></div>)
                            }/>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6} >
                            <Tile type="sales" title={DailySales} data={
                                branch.salesThisDay.map((b,i) => 
                                    <div key={i}>
                                        <div className="Amount">{numeral((b.processedAmount+b.unProcessedAmount)/100).format('0,0.00')}</div>
                                        <div className="AmountSmall">{<FontIcon className="material-icons" style={iconStyle}>cached</FontIcon>}  {numeral(b.processedAmount/100).format('0,0.00')} {<FontIcon className="material-icons" style={iconStyle}>mail_outline</FontIcon>}  {numeral(b.unProcessedAmount/100).format('0,0.00')}</div>
                                        <div className="Currency">{b.currency}</div>
                                    </div>
                                )
                            }/>
                        </Col>
                    </Row>
                    <DeviceStatusList status={branch.devices}/>
                </Grid>
                <Grid fluid className="noXsPadding">
                    <Row middle="xs">
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div className="MiddleHeader">
                                <FontIcon className="material-icons left">swap_horiz</FontIcon>
                                <div className="MiddleHeaderText">{TransactionDays}</div>
                            </div>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6} style={{textAlign: 'right'}}>
                            <div className="MiddleHeader">
                                <TransactionDayPicker openTransactionDayPick={openTransactionDayPick}/>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <TransactionDayList days={branch.transactionDayDTOList} openTransactionDay={openTransactionDay} openTransactionDayPick={openTransactionDayPick}/>
                        </Col>
                    </Row>
                        
                </Grid>
            </div>
        </MenuPage>
    )
};

export default translate('Branch')(Branch);



// WEBPACK FOOTER //
// ./src/components/branch/Branch.js